﻿﻿export interface IEwtSummary {
    recipientAlias: string;
    recipientAbo: string;
    lastCalcCpra: number;
    lastCalcInitialPool: number;
    lastCalcInitialPoolStatus: string;
    lastCalcDonorsNeeded: string;
    lastCalcAddedPerMonth: number;
    lastCalcExportableDays: number;
    lastCalcDonorAbo: string;
    lastCalcClcScore: number;
    lastCalcFavorability: string;
    lastCalcRawEwt: number;
    lastCalcActualResult: string;
    lastCalcInitialPoolUsed: number;
      lastCalcCprScore: number;
}
